import React, { FC, useState, useMemo, useRef } from "react";
import Drawer from "../drawer/Drawer";
import useWindowSize from "../../hooks/useWindowSize";
import { NavLink } from "react-router-dom";
import CustomButton from "../kits/custom-button/CustomButton";

interface InsufficientProductDrawerProps {
  supplierId: number;
  productTitles: string[];
  isOpened: boolean;
  setIsOpened: React.Dispatch<React.SetStateAction<boolean>>;
  payButtonHandler?: React.MouseEventHandler<HTMLButtonElement>;
}

const InsufficientProductDrawer: FC<InsufficientProductDrawerProps> = ({
  supplierId,
  productTitles,
  isOpened,
  setIsOpened,
  payButtonHandler,
}) => {
  const textRef = useRef<HTMLDivElement>(null);

  // width of drawer depending on the width of the window
  const drawerHeight = useMemo(() => {
    if (
      typeof textRef.current?.clientHeight === "undefined"
    )
      return 200;
    return 120 + textRef.current?.clientHeight;
  }, [textRef.current?.clientHeight]);

  return (
    <Drawer
      isOpen={isOpened}
      onClose={() => setIsOpened(false)}
      height={drawerHeight}
      className=""
      fixedChildren=""
      onScroll=""
    >
      <div className="pd-x-20 parent-drawer">
        <div className="demo-content">
          <div
            ref={textRef}
            className="title mr-t-16 desc-c-l"
            style={{ height: 70 }}
          >
            موجودی {productTitles.map((v) => `"${v}"`).join(" و ")} تمام شده و
            از سبد خرید شما حذف شده است.
          </div>
          <div className="mr-t-40 ">
            <div className="d-flex justify-content-between mr-t-20">
              {payButtonHandler ? (
                <CustomButton
                  className="btn-yes txt-t1-m"
                  buttonStyle="primary"
                  size="medium"
                  // @ts-ignore
                  onClick={payButtonHandler}
                >
                  پرداخت
                </CustomButton>
              ) : (
                <NavLink
                  to={`/check-out/${supplierId}`}
                  className="text-decoration-none"
                >
                  <CustomButton
                    className="btn-yes txt-t1-m"
                    buttonStyle="primary"
                    size="medium"
                  >
                    پرداخت
                  </CustomButton>
                </NavLink>
              )}

              <NavLink
                to={`/shop/${supplierId}`}
                className="text-decoration-none color-nav"
              >
                <CustomButton
                  buttonStyle="text"
                  size="large"
                  className="btn-no txt-t1-m"
                  type="button"
                >
                  منو سوپرمارکت
                </CustomButton>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default InsufficientProductDrawer;
